<div class="d-flex align-content-center gap-3">
    <div class="range col-sm-1">
        <input type="range" class="slider" :min="min" :max="max" :step="step" :id="id" v-model="value">
    </div>
    <div class="label">{{label}}</div>
</div>